import { useState, useEffect } from 'react';
import api from '../utils/api';

let cache = null;
let inflight = null;

/** Clear cached types (e.g. after re-seeding `document_types`). */
export function invalidateDocumentTypesCache() {
  cache = null;
  inflight = null;
}

/** Prefer `other` when present; else first seeded type (before load, use `'other'`). */
export function defaultDocumentTypeCode(documentTypes) {
  const list = Array.isArray(documentTypes) ? documentTypes : [];
  if (!list.length) return 'other';
  if (list.some((t) => t.code === 'other')) return 'other';
  return list[0].code;
}

/**
 * Document types from `document_types` (global catalog), via GET /documents/document-types.
 * Same list drives Documents, Accounts, Contacts, and admin views that import this hook.
 */
export default function useDocumentTypes() {
  const [items, setItems] = useState(cache);
  const [loading, setLoading] = useState(cache == null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cache) {
      setItems(cache);
      setLoading(false);
      return;
    }
    if (!inflight) {
      inflight = api
        .get('/documents/document-types')
        .then((r) => {
          const list = Array.isArray(r.data?.data) ? r.data.data : [];
          cache = list;
          return list;
        })
        .catch((e) => {
          setError(e);
          return [];
        })
        .finally(() => {
          inflight = null;
        });
    }
    inflight.then((list) => {
      setItems(list);
      setLoading(false);
    });
  }, []);

  return { documentTypes: items || [], loading, error };
}

export function labelForDocumentType(code, documentTypes) {
  if (!code || !Array.isArray(documentTypes)) return code || '';
  const row = documentTypes.find((t) => t.code === code);
  return row?.label || String(code).replace(/_/g, ' ');
}
